import React, { useCallback } from 'react';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	changePriceType: (value: string) => void;
}

export const PriceTypeField: React.FC<IProps> = React.memo(({ changePriceType }) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
			changePriceType(valueWithoutSpaces);
			return valueWithoutSpaces;
		},
		[changePriceType],
	);

	return (
		<FormInputNew
			testId="PriceTypeField"
			name="priceType"
			label="priceTypeLabel"
			getValueFromEvent={handleChange}
		/>
	);
});
